import { Alert, Button, Input, Modal } from 'antd';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

import * as Yup from 'yup';

import './index.scss';
import { deleteLibrary } from '../../../redux/auth/authCrud';
import { AxiosError } from '../../../../interface';
import { shallowEqual, useSelector } from 'react-redux';
import { HibraryRootState } from '../../../../redux/rootReducer';

interface DeleteAccountModalProps {
    visible: boolean;
    onCancel: () => void;
}

interface FormPayload {
    password?: string;
    clientUID: string;
}

enum inputType {
    password = 'password',
    text = 'text'
}

const DeleteLibraryModal = (props: DeleteAccountModalProps) => {
    const history = useHistory();
    const [input, setInput] = useState<inputType>(inputType.password);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);

    const { authen } = useSelector(
        (state: HibraryRootState) => ({
            authen: state.auth
        }),
        shallowEqual
    );
    const schema = Yup.object().shape({
        password: Yup.string().required('กรุณากรอกรหัสผ่าน')
    });

    const formik = useFormik({
        initialValues: {
            password: '',
            clientUID: authen.userInfo?.clientUID
        } as FormPayload,
        validationSchema: schema,
        onSubmit: (value) => {
            // alert(JSON.stringify(value));
            onDeleteLibrary(value);
        }
    });

    const onDeleteLibrary = async (value: FormPayload) => {
        try {
            setButtonLoading(true);
            const response = await deleteLibrary(value.password!, value.clientUID);
            if (response.status) {
                setButtonLoading(false);
                props.onCancel();
                history.push('/logout');
            }
        } catch (error) {
            const { response } = error as AxiosError;
            formik.setFieldError('password', response.data.message);
            setButtonLoading(false);
        }
    };

    return (
        <Modal
            title={null}
            footer={null}
            visible={props.visible}
            onCancel={props.onCancel}
            className='delete-account-modal'
        >
            <h2>ยืนยันการลบห้องสมุด</h2>
            <p className='text'>กรอกรหัสผ่านเพื่อยืนยันการลบห้องสมุด</p>
            <div>
                <p style={{ marginBottom: '0.25rem' }}>รหัสผ่าน</p>
                <Input
                    id='password'
                    name='password'
                    autoComplete='new-password'
                    type={input}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    placeholder='กรอกรหัสผ่าน'
                    suffix={
                        input === inputType.text ? (
                            <EyeInvisibleOutlined onClick={() => setInput(inputType.password)} />
                        ) : (
                            <EyeOutlined onClick={() => setInput(inputType.text)} />
                        )
                    }
                />
            </div>

            {formik.errors.password && formik.touched.password && (
                <Alert
                    message={formik.errors.password}
                    type='error'
                    showIcon
                    style={{ marginBottom: '1rem' }}
                />
            )}

            <div className='button-contain'>
                <Button
                    shape='round'
                    size='large'
                    className='cancel-button'
                    onClick={() => {
                        props.onCancel();
                        formik.resetForm();
                    }}
                >
                    ยกเลิก
                </Button>
                <Button
                    shape='round'
                    size='large'
                    type='primary'
                    danger
                    onClick={() => formik.handleSubmit()}
                    loading={buttonLoading}
                >
                    ลบห้องสมุด
                </Button>
            </div>
        </Modal>
    );
};

export default DeleteLibraryModal;
